import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../../Components/Navbar';
import Footer from '../../../Components/Footer';
import { apiDelete, apiGet, apiPost, apiPut } from '../../../API/Api_Url';
import { ArrowLeft, Calendar, Clock, DollarSign, FileCheck, Home, MapPin, Users } from 'lucide-react';
import { FaComment, FaEllipsisV, FaStar } from 'react-icons/fa';
import { toast } from 'react-toastify';

const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
};

const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case 'rebid':
            return 'border-yellow-500 text-yellow-600';
        case 'ongoing':
            return 'border-yellow-500 text-yellow-600';
        case 'accepted':
            return 'border-green-500 text-green-600';
        case 'completed':
            return 'border-green-500 text-green-600';
        case 'rejected':
            return 'border-red-500 text-red-600';
        case 'pending':
            return 'border-red-500 text-red-600';
        default:
            return 'border-gray-500 text-gray-600';
    }
};

function RequirementDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [Requirement, setRequirement] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const GetRequirementDetail = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/user/UserGetARequirementDetails/${id}`);
            setRequirement(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        GetRequirementDetail();
    }, [id]);

    const [AllTracker, setAllTracker] = useState([]);

    const GetRequirementTracker = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/user/UserGetARequirementTracking/${id}`);
            setAllTracker(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        GetRequirementTracker();
    }, [id]);

    const [AllReview, setAllReview] = useState([]);

    const GetReview = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(`api/user/GetReviewOfARequirement/${id}`);
            setAllReview(response?.data);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        GetReview();
    }, [id]);



    const [commentInputs, setCommentInputs] = useState({});

    const handleCommentSubmit = async (id) => {
        const payload = {
            CommentText: "User -" + " " + commentInputs[id] || "",
        };
        if (!payload.CommentText.trim()) return;

        try {
            setIsUploading(true);
            const response = await apiPost(`/api/user/AddRequirementTrackingComment/${id}`, payload);
            toast.success(response?.data?.message || response?.message);

            setCommentInputs((prev) => ({ ...prev, [id]: "" }));

            GetRequirementTracker();
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsUploading(false);
        }
    };

    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [review, setReview] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [menuOpenId, setMenuOpenId] = useState(null);

    const Createreview = async () => {
        if (!rating || !review) {
            toast.error("Please provide both rating and review.");
            return;
        }
        const payload = {
            Requirement: id,
            Contractor: Requirement?.SelectedContractor[0].Contractor,
            Rating: rating,
            Review: review
        };
        try {
            setIsUploading(true);
            const response = await apiPost(`/api/user/UserCreateRequirementReview`, payload);
            toast.success(response?.data?.message || response?.message);
            GetReview();
            setRating(0);
            setReview("");
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsUploading(false);
        }

    }

    const handleEdit = (review) => {
        setEditingId(review._id);
        setRating(review?.Rating);
        setReview(review?.Review);
        setMenuOpenId(null);
    };

    const UpdateReview = async () => {
        if (!rating || !review) {
            toast.error("Please provide both rating and review.");
            return;
        }
        const payload = {
            Rating: rating,
            Review: review
        };
        try {
            setIsUploading(true);
            const response = await apiPut(`/api/user/UpdateAReview/${editingId}`, payload);
            toast.success(response?.data?.message || response?.message);
            GetReview();
            setRating(0);
            setReview("");
            setEditingId(null)
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsUploading(false);
        }
    }

    const DeleteReview = async (id) => {
        try {
            setIsUploading(true);
            const response = await apiDelete(`/api/user/DeleteAReview/${id}`);
            toast.success(response?.data?.message || response?.message);
            GetReview();
            setEditingId(null)
            setMenuOpenId(null);
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsUploading(false);
        }
    }

    if (isUploading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="text-gray-600 text-lg">Loading...</div>
            </div>
        );
    }

    if (!Requirement) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <div className="text-gray-600 text-lg">No data found</div>
            </div>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container mx-auto px-4 py-8 pt-[10%]">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
                >
                    <ArrowLeft className="h-5 w-5" />
                    Back to Requirements
                </button>
                <div className="bg-white rounded-2xl shadow-lg p-6 mx-auto">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-bold text-gray-900">{Requirement?.ProjectType} Details</h2>
                        <span
                            className={`px-3 py-1 text-sm font-semibold rounded-full border ${getStatusColor(Requirement?.Status)}`}
                        >
                            {Requirement?.Status}
                        </span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Project Information</h3>
                            <div className="space-y-3 text-sm text-gray-600">
                                <div className="flex items-center">
                                    <Home className="h-5 w-5 mr-2 text-blue-500" />
                                    <div>
                                        <p className="font-medium">Size</p>
                                        <p>
                                            {Requirement?.SizeDimension?.Length} x {Requirement?.SizeDimension?.Breadth}{' '}
                                            {Requirement?.SizeDimension?.Unit} ({Requirement.SizeDimension?.Area})
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <Users className="h-5 w-5 mr-2 text-green-500" />
                                    <div>
                                        <p className="font-medium">Floors</p>
                                        <p>{Requirement?.NumberOfFloors}</p>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <DollarSign className="h-5 w-5 mr-2 text-purple-500" />
                                    <div>
                                        <p className="font-medium">Budget</p>
                                        <p>{Requirement?.Budget}</p>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <p className="font-medium">Payment Method</p>
                                    <p className="ml-2">{Requirement?.PaymentMethod}</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="flex items-center">
                                <Clock className="h-5 w-5 mr-2 text-orange-500" />
                                <div>
                                    <p className="font-medium">Timeline</p>
                                    <p>{Requirement?.TimelineInMonths} months</p>
                                </div>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2 mt-2">Location</h3>
                            <div className="flex items-start text-gray-600 text-sm">
                                <MapPin className="h-5 w-5 mr-2 text-blue-500 mt-1" />
                                <p>
                                    <a
                                        href={`https://www.google.com/maps?q=${Requirement?.Location?.Late},${Requirement?.Location?.Long}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:underline"
                                    >
                                        {Requirement?.Location?.Address}, {Requirement?.City}, {Requirement?.State} - {Requirement?.Pincode}
                                    </a>
                                </p>
                            </div>
                            {Requirement?.NeedLocalAuthorityApproval && (
                                <div className="flex items-center text-sm text-red-600 font-medium mt-3">
                                    <FileCheck className="h-5 w-5 mr-2" />
                                    <span>Requires Local Authority Approval</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {Requirement?.SelectedContractor?.length > 0 && (
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold text-gray-800 mb-3">Selected Contractors</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {Requirement?.SelectedContractor?.map((contractor, idx) => (
                                    <div
                                        key={contractor?._id || idx}
                                        className="border border-green-200 rounded-lg p-4 bg-gray-50"
                                    >
                                        <div className="space-y-2 text-sm text-gray-600">
                                            <p>
                                                <span className="font-medium text-gray-800">Price:</span>{' '}
                                                <span className="text-green-700 font-semibold">₹{contractor?.Price}</span>
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-800">Site Visit:</span>{' '}
                                                <span
                                                    className={
                                                        contractor?.SiteVisit ? 'text-green-600 font-semibold' : 'text-red-500 font-semibold'
                                                    }
                                                >
                                                    {contractor?.SiteVisit ? 'Yes' : 'No'}
                                                </span>
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-800">Project Manager:</span>{' '}
                                                <span
                                                    className={
                                                        contractor?.ProjectManager ? 'text-green-600 font-semibold' : 'text-red-500 font-semibold'
                                                    }
                                                >
                                                    {contractor?.ProjectManager ? 'Yes' : 'No'}
                                                </span>
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-800">Report Frequency:</span>{' '}
                                                <span className="font-semibold">{contractor?.Reportfrequency}</span>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {Requirement?.AdminSelectedbids?.length > 0 && (
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold text-gray-800 mb-3">Admin Selected Bids</h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {Requirement?.AdminSelectedbids?.map((bid, idx) => (
                                    <div
                                        key={bid?._id || idx}
                                        className="border border-blue-200 rounded-lg p-4 bg-gray-50"
                                    >
                                        <div className="space-y-2 text-sm text-gray-600">
                                            <p>
                                                <span className="font-medium text-gray-800">Name:</span> {bid?.Name}
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-800">Contractor ID:</span>{' '}
                                                <span className="font-mono">{bid?.Contractor}</span>
                                            </p>
                                            <p>
                                                <span className="font-medium text-gray-800">Price:</span>{' '}
                                                <span className="text-blue-700 font-semibold">₹{bid?.Price}</span>
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="mt-6 bg-gray-50 p-4 rounded-lg">
                        <h3 className="text-lg font-semibold text-gray-800 mb-3">Agreement Status</h3>
                        <div className="flex flex-col md:flex-row gap-4 text-sm text-gray-600">
                            <p>
                                <span
                                    className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                                        Requirement?.AdminAgreementRequest
                                    )}`}
                                >
                                    Admin Agreement: {Requirement?.AdminAgreementRequest}
                                </span>
                            </p>
                            <p>
                                <span
                                    className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                                        Requirement?.UserAgreementRequest
                                    )}`}
                                >
                                    User Agreement: {Requirement?.UserAgreementRequest}
                                </span>
                            </p>
                        </div>
                    </div>

                    {Requirement?.RequirementHistory?.length > 0 && (
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold text-gray-800 mb-3">Requirement History</h3>
                            <div className="space-y-4">
                                {Requirement?.RequirementHistory?.map((history, idx) => (
                                    <div
                                        key={history?._id || idx}
                                        className="border border-gray-200 rounded-lg p-4 bg-gray-50"
                                    >
                                        <div className="flex justify-between items-center mb-2">
                                            <p className="text-sm text-gray-600">
                                                <span className="font-medium">Updated:</span> {formatDate(history?.createdAt)}
                                            </p>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                                            <div>
                                                <p className="font-medium text-gray-800">Old Data</p>
                                                <p>Size: {history?.OldData?.SizeDimension?.Length} x {history?.OldData?.SizeDimension?.Breadth} {history?.OldData?.SizeDimension?.Unit}</p>
                                                <p>Floors: {history?.OldData?.NumberOfFloors}</p>
                                            </div>
                                            <div>
                                                <p className="font-medium text-gray-800">New Data</p>
                                                <p>Size: {history?.NewData?.SizeDimension?.Length} x {history?.NewData?.SizeDimension?.Breadth} {history?.NewData?.SizeDimension?.Unit}</p>
                                                <p>Floors: {history?.NewData?.NumberOfFloors}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="mt-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-4">📌 Requirement Tracking</h3>
                        {AllTracker?.length > 0 ? (

                            <div className="space-y-6">
                                {AllTracker?.map((tracker, idx) => (
                                    <div
                                        key={tracker?._id || idx}
                                        className="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm hover:shadow-md transition"
                                    >
                                        <div className="flex justify-between items-center mb-4">
                                            <h4 className="text-lg font-semibold text-gray-900">{tracker?.Title}</h4>
                                            <span
                                                className={`px-3 py-1 text-xs font-semibold rounded-full shadow-sm ${getStatusColor(
                                                    tracker?.Status
                                                )}`}
                                            >
                                                {tracker?.Status}
                                            </span>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 text-sm text-gray-700 mb-4">
                                            <p>
                                                <span className="font-medium">📄 Description:</span> {tracker.Description}
                                            </p>
                                            <p>
                                                <span className="font-medium">⏳ Start Date:</span> {tracker?.StartDate}
                                            </p>
                                            <p>
                                                <span className="font-medium">✅ End Date:</span> {tracker?.EndDate}
                                            </p>
                                            <p>
                                                <span className="font-medium">🕒 Created:</span> {formatDate(tracker?.createdAt)}
                                            </p>
                                        </div>

                                        {tracker?.Media?.length > 0 && (
                                            <div className="mt-4">
                                                <p className="text-sm font-semibold text-gray-800 mb-2">📸 Media</p>
                                                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                                    {tracker?.Media?.map((media, mediaIdx) => (
                                                        <div
                                                            key={media?._id || mediaIdx}
                                                            className="relative group overflow-hidden rounded-lg shadow"
                                                        >
                                                            {media?.FileType === "image" ? (
                                                                <img
                                                                    src={media?.FileUrl}
                                                                    alt="Tracker media"
                                                                    className="w-full h-32 object-cover rounded-lg transform group-hover:scale-105 transition duration-300"
                                                                />
                                                            ) : media?.FileType === "video" ? (
                                                                <video
                                                                    src={media?.FileUrl}
                                                                    controls
                                                                    className="w-full h-32 object-cover rounded-lg bg-black"
                                                                />
                                                            ) : (
                                                                <div className="w-full h-32 flex items-center justify-center bg-gray-200 text-gray-500 rounded-lg text-sm">
                                                                    Unsupported file
                                                                </div>
                                                            )}
                                                            <p className="text-xs text-gray-500 mt-1">
                                                                Uploaded: {formatDate(media?.UploadedAt)}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className="mt-6">
                                            <p className="text-sm font-semibold text-gray-800 mb-3">💬 Comments</p>
                                            {tracker?.Comments?.length > 0 ? (
                                                <div className="space-y-3">
                                                    {tracker?.Comments.map((comment, commentIdx) => (
                                                        <div
                                                            key={commentIdx}
                                                            className="bg-blue-50 border border-blue-100 p-3 rounded-lg text-sm text-gray-700 shadow-sm"
                                                        >
                                                            <p>{comment?.CommentText}</p>
                                                            <p className="text-xs text-gray-500 mt-1">
                                                                {formatDate(comment?.CreatedAt)}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-sm text-gray-500">No comments yet</p>
                                            )}

                                            <div className="mt-4">
                                                <textarea
                                                    value={commentInputs[tracker._id] || ""}
                                                    onChange={(e) =>
                                                        setCommentInputs({ ...commentInputs, [tracker._id]: e.target.value })
                                                    }
                                                    placeholder="Write your comment..."
                                                    className="w-full p-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    rows="3"
                                                    disabled={isUploading}
                                                />
                                                <button
                                                    onClick={() => handleCommentSubmit(tracker._id)}
                                                    className="mt-2 px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center"
                                                    disabled={isUploading}
                                                >
                                                    <FaComment className="inline-block h-4 w-4 mr-2" />
                                                    Submit Comment
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <p className="text-sm text-gray-500">No tracking data available</p>
                        )}
                    </div>
                    {
                        Requirement?.Status === 'Completed' && (
                            <>
                                {AllReview.length === 0 ? (
                                    <div className="w-full mx-auto p-6 bg-white rounded-xl shadow-md space-y-4 mt-4">
                                        <h2 className="text-lg font-semibold text-gray-800">Write a Review</h2>

                                        <div className="flex items-center gap-2">
                                            {[...Array(5)]?.map((_, index) => {
                                                const starValue = index + 1;
                                                return (
                                                    <FaStar
                                                        key={index}
                                                        className={`cursor-pointer transition ${starValue <= (hover || rating)
                                                            ? "text-yellow-400"
                                                            : "text-gray-300"
                                                            }`}
                                                        onClick={() => setRating(starValue)}
                                                        onMouseEnter={() => setHover(starValue)}
                                                        onMouseLeave={() => setHover(0)}
                                                        size={24}
                                                    />
                                                );
                                            })}
                                        </div>

                                        <textarea
                                            value={review}
                                            onChange={(e) => setReview(e.target.value)}
                                            placeholder="Write your review..."
                                            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                            rows="4"
                                        />

                                        <button
                                            onClick={() => Createreview()}
                                            className="w-full bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition"
                                        >
                                            Submit Review
                                        </button>
                                    </div>
                                ) : (
                                    AllReview?.map((rev) => (
                                        <div
                                            key={rev?._id}
                                            className="w-full mx-auto p-6 bg-white rounded-xl shadow-md space-y-4 mt-4"
                                        >
                                            <div className="flex items-center justify-between">
                                                <h2 className="text-lg font-semibold text-gray-800">Your Review</h2>

                                                <div className="relative">
                                                    <button
                                                        onClick={() =>
                                                            setMenuOpenId(menuOpenId === rev._id ? null : rev._id)
                                                        }
                                                        className="p-2 rounded-full hover:bg-gray-200"
                                                    >
                                                        <FaEllipsisV />
                                                    </button>

                                                    {menuOpenId === rev._id && (
                                                        <div className="absolute right-0 mt-2 w-32 bg-white border rounded-lg shadow-lg z-10">
                                                            <button
                                                                onClick={() => handleEdit(rev)}
                                                                className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                                                            >
                                                                Update
                                                            </button>
                                                            <button
                                                                onClick={() => DeleteReview(rev._id)}
                                                                className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-500"
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-1">
                                                {[...Array(5)]?.map((_, index) => (
                                                    <FaStar
                                                        key={index}
                                                        className={`${index + 1 <= rev?.Rating ? "text-yellow-400" : "text-gray-300"
                                                            }`}
                                                        size={20}
                                                    />
                                                ))}
                                            </div>
                                            <p className="text-gray-700">{rev?.Review}</p>
                                        </div>
                                    ))
                                )}

                                {editingId && (
                                    <div className="w-full mx-auto mt-4 p-6 bg-gray-50 border rounded-xl space-y-4 ">
                                        <h2 className="text-lg font-semibold text-gray-800">Update Review</h2>

                                        <div className="flex items-center gap-2">
                                            {[...Array(5)].map((_, index) => {
                                                const starValue = index + 1;
                                                return (
                                                    <FaStar
                                                        key={index}
                                                        className={`cursor-pointer transition ${starValue <= (hover || rating)
                                                            ? "text-yellow-400"
                                                            : "text-gray-300"
                                                            }`}
                                                        onClick={() => setRating(starValue)}
                                                        onMouseEnter={() => setHover(starValue)}
                                                        onMouseLeave={() => setHover(0)}
                                                        size={24}
                                                    />
                                                );
                                            })}
                                        </div>

                                        <textarea
                                            value={review}
                                            onChange={(e) => setReview(e.target.value)}
                                            placeholder="Update your review..."
                                            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                            rows="4"
                                        />

                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => UpdateReview(editingId)}
                                                className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition"
                                            >
                                                Save Changes
                                            </button>
                                            <button
                                                onClick={() => setEditingId(null)}
                                                className="bg-gray-400 text-white py-2 px-4 rounded-lg hover:bg-gray-500 transition"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )
                    }


                    <div className="mt-6 pt-4 border-t border-gray-200 flex justify-between text-sm text-gray-600">
                        <div className="flex items-center">
                            <Calendar className="h-5 w-5 mr-2" />
                            <span>Created: {formatDate(Requirement?.createdAt)}</span>
                        </div>
                        <div className="flex items-center">
                            <Calendar className="h-5 w-5 mr-2" />
                            <span>Updated: {formatDate(Requirement?.updatedAt)}</span>
                        </div>
                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}

export default RequirementDetail;